module.exports = __webpack_public_path__ + "static/img/8.246f068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/8.png
// module id = sU5o
// module chunks = 0